import { Button, Paper, TextField, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import { ManagerAuthResponse } from "../interfaces/Manager";
import { ResponseContainer } from "../interfaces/RequestBase";
import { Auth } from "../requester/functions";

interface IProps {
	onAuth(data: ManagerAuthResponse): void;
}

const AuthPage = (props: IProps) => {
	const [password, setPassword] = useState<string>("");
	const [login, setLogin] = useState<string>("");
	const [error, setError] = useState<boolean>(false);

	const theme = useTheme();

	const onAuth = (resp: ResponseContainer<ManagerAuthResponse>) => {
		if (resp.status === "error") {
			setError(true);
		} else {
			if (resp.data) {
				props.onAuth(resp.data);
			}
		}
	};

	return (
		<div className="w-full flex justify-center items-center h-[100vh]">
			<Paper className="flex flex-col gap-4 p-10">
				<Typography className="text-center" variant="h4">
					Авторизация
				</Typography>
				<TextField
					variant="standard"
					label="Логин"
					required
					error={login ? false : true}
					onChange={(ev) => {
						setLogin(ev.target.value);
					}}
					onKeyUp={(ev) => {
						if (ev.key === "Enter") Auth({ login, password }, onAuth);
					}}
				/>
				<TextField
					variant="standard"
					label="Пароль"
					required
					error={password ? false : true}
					onChange={(ev) => {
						setPassword(ev.target.value);
					}}
					onKeyUp={(ev) => {
						if (ev.key === "Enter") Auth({ login, password }, onAuth);
					}}
					type="password"
				/>
				<Button
					disabled={password && login ? false : true}
					variant={"contained"}
					onClick={() => {
						Auth({ login, password }, onAuth);
					}}
				>
					Войти
				</Button>
				{error ? (
					<Typography color={theme.palette.error.main}>
						Неверный логин или пароль
					</Typography>
				) : null}
			</Paper>
		</div>
	);
};

export default AuthPage;
